import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-rate-of-return-tooltip',
    styleUrls: ['rate-of-return-tooltip.component.scss'],
    templateUrl: `rate-of-return-tooltip.component.html`
})
export class RateOfReturnTooltipComponent {
    @Input('placement')
    public readonly placement: 'top' | 'right' | 'bottom' | 'left' = 'top';
}